import { h } from 'preact';

const BestSellers = (bestSellers) => (
  <div className="pl-5 pr-0 lg:px-10 pb-5">
    <div className="flex justify-between pb-3 lg:pr-0 pr-3">
      <div className="label-12 uppercase tracking-[2px] text-grey-2A">{bestSellers[0].title}</div>
      <div>
        <a href={bestSellers[0].shopAll} className="body-xs">Shop all</a>
      </div>
    </div>
    <div className="flex gap-2.5 overflow-x-auto pb-5">
      {bestSellers[0].cards.map((item) => (
        <a key={item.url} href={item.url} className="no-underline [&_span]:hover:link-list shrink-0 w-36 lg:w-[calc(33.3333%-0.625rem*(2/3))]">
          <img src={item.image} alt="" className="block mb-2 w-full" />
          <span className="!body-xs block !leading-4 link-list no-underline">{item.title}</span>
        </a>
      ))}
    </div>
  </div>
)

export default BestSellers;